import React, { useState, useEffect } from 'react';
import { playRatingSound } from '../utils/sound';
import './RatingModal.css';

export function RatingModal({ show, onClose, onSubmit, currentRating = 0 }) {
  const [rating, setRating] = useState(currentRating);
  const [hoveredRating, setHoveredRating] = useState(0);

  useEffect(() => {
    if (currentRating > 0) {
      onSubmit(currentRating);
    }
  }, [currentRating, onSubmit]);

  return (
    <div className="modal-overlay">
      <div className="rating-modal">
        <h3>Rösta på "{show.title}" before sharing</h3>
        <div className="rating-stars">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              className="rating-star"
              onClick={() => {
                setRating(star);
                onSubmit(star);
              }}
              onMouseEnter={() => setHoveredRating(star)}
              onMouseLeave={() => setHoveredRating(0)}
            >
              <img 
                src={star <= (hoveredRating || rating) 
                  ? "/images/strawberry-filled.png" 
                  : "/images/strawberry-empty.png"} 
                alt={`Rating ${star}`}
                className="strawberry-icon"
              />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
} 